import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from '../../Utils/toast';
import { useCreateNanihalGotraMutation } from '../../redux/services/nanihalGotraService/nanihalGotra.Services';

function AddNanihalGotra() {
    const navigate = useNavigate();
    const [createGotra, { isLoading }] = useCreateNanihalGotraMutation();
    const [formData, setFormData] = useState({
        nanihal_gotra_name: '',
        status: 'active',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nanihal_gotra_name.trim()) {
            errorToast('Error', 'Gotra name is required');
            return;
        }

        try {
            await createGotra(formData).unwrap();
            successToast('Success', 'Gotra created successfully');
            navigate('/nanihal-gotra');
        } catch (error) {
            console.error('Create error:', error);
            errorToast('Error', error?.data?.message || 'Failed to create gotra');
        }
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Add Gotra</h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/nanihal-gotra">Gotra List</Link>
                            </li>
                            <li className="breadcrumb-item">Add Gotra</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate("/nanihal-gotra")}
                    >
                        Gotra List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Gotra Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Gotra Name"
                                            name="nanihal_gotra_name"
                                            value={formData.nanihal_gotra_name}
                                            onChange={handleChange}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="button_submit">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" />
                                                        Creating...
                                                    </>
                                                ) : (
                                                    'Submit'
                                                )}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary ms-2"
                                                onClick={() => navigate("/nanihal-gotra")}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddNanihalGotra;